export default __webpack_public_path__ + "static/media/SHOWG.464936a8.TTF";